import type { LocationQueryRaw, NavigationFailure } from 'vue-router'

interface RefreshQueryReturn {
  refreshQuery: (query: LocationQueryRaw) => Promise<NavigationFailure | void | undefined>
}

/**
 * Navigates to the query and forces it, so the page rereads its data even when the URL stays the same. An unchanged URL
 * replaces the history entry instead of stacking a duplicate one that Back would step through.
 */
export const useRefreshQuery = (): RefreshQueryReturn => {
  const router = useRouter()

  const refreshQuery = (query: LocationQueryRaw): Promise<NavigationFailure | void | undefined> => {
    const isSameUrl = router.resolve({ query }).fullPath === router.currentRoute.value.fullPath

    return router.push({ query, force: true, replace: isSameUrl })
  }

  return {
    refreshQuery,
  }
}
